import { computed } from 'vue'
import { useSessionModule } from '@/modules/session'

import {
    EmployeeRouteNames,
    AuthenticationLogsRouteNames,
    FailedLoginAttemptsRouteNames,
    WhitelistedIpsRouteNames,
    MembersRouteNames,
    OrganizationsRouteNames,
    JobTitlesRouteNames,
    PackagesRouteNames,
    FreeFormsRouteNames,
    FreeSubscriptionsRouteNames,
    AgreementsRouteNames,
    ElectronicOperatorsRouteNames,
    InvoicesRouteNames,
    SSOJoinRulesRouteNames,
    AuditLogsRouteNames,
    IndustriesRouteNames
} from '@/router/routes-names'

export type MenuItem = {
    label: string,
    children?: MenuItem[],
    to?: { name: string, query: { page: string } },
    icon?: string,
    path?: string
}

const { isOperatorSecurityAdmin } = useSessionModule()

function defaultMenu (): MenuItem[] {
    return [
        {
            label: 'Members',
            icon: 'groups',
            to: { name: MembersRouteNames.LIST, query: { page: '1' } },
            path: '/members'
        },
        {
            label: 'Organizations',
            icon: 'business',
            to: { name: OrganizationsRouteNames.LIST, query: { page: '1' } },
            path: '/organizations'
        },
        {
            label: 'Job Titles',
            icon: 'perm_identity',
            to: { name: JobTitlesRouteNames.LIST, query: { page: '1' } },
            path: '/job-titles'
        },
        {
            label: 'Industries',
            icon: 'precision_manufacturing',
            to: { name: IndustriesRouteNames.LIST, query: { page: '1' } },
            path: '/industries'
        },
        {
            label: 'Packages',
            icon: 'inventory',
            to: { name: PackagesRouteNames.LIST, query: { page: '1' } },
            path: '/packages'
        },
        {
            label: 'Free Forms',
            icon: 'list',
            to: { name: FreeFormsRouteNames.LIST, query: { page: '1' } },
            path: '/free-forms'
        },
        {
            label: 'Free Subscriptions',
            icon: 'assignment_ind',
            to: { name: FreeSubscriptionsRouteNames.LIST, query: { page: '1' } },
            path: '/free-subscription'
        },
        {
            label: 'Agreements',
            icon: 'gavel',
            to: { name: AgreementsRouteNames.LIST, query: { page: '1' } },
            path: '/agreements'
        },
        {
            label: 'Invoices',
            icon: 'receipt',
            to: { name: InvoicesRouteNames.LIST, query: { page: '1' } },
            path: '/invoices'
        },
        {
            label: 'Electronic operators',
            icon: 'account_balance',
            to: { name: ElectronicOperatorsRouteNames.LIST, query: { page: '1' } },
            path: '/electronic-operators'
        },
        {
            label: 'SSO Join Rules',
            icon: 'key',
            to: { name: SSOJoinRulesRouteNames.LIST, query: { page: '1' } },
            path: '/sso-join-rules'
        }
    ]
}

function decorateWithSecurityMenu (menu: MenuItem[]): MenuItem[] {
    const item = {
        label: 'Security',
        icon: 'security',
        children: [
            {
                label: 'Employees',
                to: { name: EmployeeRouteNames.LIST, query: { page: '1' } },
                path: '/employees'
            },
            {
                label: 'Audit logs',
                to: { name: AuditLogsRouteNames.LIST, query: { page: '1' } },
                path: '/audit-logs'
            },
            {
                label: 'Authentication logs',
                to: { name: AuthenticationLogsRouteNames.LIST, query: { page: '1' } },
                path: '/authentication-logs'
            },
            {
                label: 'Whitelisted IPs',
                to: { name: WhitelistedIpsRouteNames.LIST, query: { page: '1' } },
                path: '/whitelisted-ips'
            },
            {
                label: 'Failed Login Attempts',
                to: { name: FailedLoginAttemptsRouteNames.LIST, query: { page: '1' } },
                path: '/failed-login-attempts'
            }
        ]
    }
    return [item, ...menu]
}

export function useLayoutModule () {
    return {
        menu: computed(() => {
            let menu = defaultMenu()
            if (isOperatorSecurityAdmin.value) {
                menu = decorateWithSecurityMenu(menu)
            }
            return menu
        })
    }
}
